import { render, staticRenderFns } from "./menuAdmision.vue?vue&type=template&id=5ff793a4&scoped=true"
import script from "./menuAdmision.vue?vue&type=script&lang=js"
export * from "./menuAdmision.vue?vue&type=script&lang=js"
import style0 from "./menuAdmision.vue?vue&type=style&index=0&id=5ff793a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff793a4",
  null
  
)

export default component.exports